module.exports = __webpack_public_path__ + "static/media/moonspecsHero.b23d13d7.jpg";